import { render, staticRenderFns } from "./process_dialog.vue?vue&type=template&id=01c22382&scoped=true"
import script from "./process_dialog.vue?vue&type=script&lang=js"
export * from "./process_dialog.vue?vue&type=script&lang=js"
import style0 from "./process_dialog.vue?vue&type=style&index=0&id=01c22382&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c22382",
  null
  
)

export default component.exports